import { forwardRef, useMemo } from 'react'
import { Switch as RNSwitch } from 'react-native'

import { FormInput, Switch, SwitchProps, type FormInputProps } from '@/components'
import { COLOR_BRAND_GREY_300, COLOR_BRAND_ORANGE_500, COLOR_WHITE, IS_WEB } from '@/lib'

export interface SwitchInputProps extends Omit<FormInputProps, 'children' | 'inlineLabel' | 'onChange'> {
  onChange: (value: boolean) => Promise<void> | void
  switchProps?: Omit<SwitchProps, 'onChange' | 'onValueChange' | 'value'>
  value?: boolean | null | undefined
}

export const SwitchInput = forwardRef<RNSwitch, SwitchInputProps>(
  ({ accessibilityLabel, helper, isDisabled, isRequired, label, onChange, switchProps, value, ...props }, ref) => {
    const checked = !!value

    return (
      <FormInput
        helper={helper}
        isDisabled={isDisabled}
        isRequired={isRequired}
        label={label}
        withInlineLabel
        {...props}
      >
        <Switch
          accessibilityLabel={useMemo(
            () => accessibilityLabel ?? `${label}${isRequired ? '. Required' : ''}${helper ? `. ${helper}` : ''}`,
            [accessibilityLabel, label, isRequired, helper]
          )}
          accessibilityState={{
            checked,
            disabled: isDisabled
          }}
          onValueChange={onChange}
          ref={ref}
          size={IS_WEB ? 'md' : 'sm'}
          thumbColor={COLOR_WHITE}
          trackColor={{
            true: COLOR_BRAND_ORANGE_500,
            false: COLOR_BRAND_GREY_300
          }}
          value={value ?? false}
          {...switchProps}
        />
      </FormInput>
    )
  }
)

SwitchInput.displayName = 'SwitchInput'
